import { ComponentProps } from 'react'

import { styled } from 'nativewind'

import Pressable from '../pressable'

import { Icon, SVGProps } from './Icon'

export const IconButtonFrame = styled(
  Pressable,
  'rounded-lg p-2 bg-grays-30 active:bg-grays-40 justify-center'
)

type IconButtonProps = ComponentProps<typeof IconButtonFrame> & SVGProps

export function IconButton({
  type,
  color = '#000',
  size = 24,
  ...props
}: IconButtonProps) {
  return (
    <IconButtonFrame {...props}>
      <Icon type={type} color={color} size={size} {...props}></Icon>
    </IconButtonFrame>
  )
}
